import React, { useEffect, useRef, useState } from "react";
import { endPointSearch } from "modules/main/services/endpoints";
import { Popover, PopoverContent,PopoverTrigger } from "@/components/ui/popover";
import { Input } from "@/components/ui/input";
import {Search} from "lucide-react";
import { Command,CommandGroup,CommandItem,CommandList } from "@/components/ui/command";
import { Navigate, useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";


interface SearchBarProps extends React.HTMLAttributes<HTMLDivElement>{
    placeHolder?:string
}

interface Predictions {
    id:number,
    brand:string,
    name:string,
    picture:string
}

export const SearchBar = React.forwardRef<HTMLDivElement,SearchBarProps>(({className,...props},ref) =>{
    const navigate = useNavigate();
    const [isOpen,setopen] = useState(false);
    const [hasTyped,setHasTyped] = useState<boolean>(false);
    const [searchText,setSearchText] = useState("");

    const [error,setError] = useState<any>(null);
    const [loading,setLoading] = useState<boolean>(true);
    const [predictions,setPredictions] = useState<Array<Predictions>>([]);

    const searhBarRef = useRef<HTMLInputElement>(null);

    useEffect(()=>{
        // const fetchResults = async() => {
        //     const url = endPointSearch(searchText);
        //     fetch(url)
        //         .then((response) => response.json())
        //         .then((json) => {
        //             console.log(hasTyped);
        //             if(json["products"].length >= 1 && hasTyped){
        //                 setopen(true);
        //             }
        //             setPredictions(json["products"]);
        //     })
        //     .catch((error)=> setError(error))
        //     .finally(()=>setLoading(false));
        // }        
        // const timeOut = setTimeout(() => {
        //     // console.log(searchText.length);
        //     if(searchText.length > 3 && hasTyped)
        //         fetchResults();
        // },500);

        // return () => clearTimeout(timeOut);

    },[searchText,hasTyped]);


    //events listeners
    useEffect( () => {
        
        const handleClick = (e:MouseEvent) => {
            if(e.target !== searhBarRef.current){
                // console.log("click outside");
                setopen(false);
            } 
            
        }
        document.addEventListener( "click", (e) => {handleClick(e)})
    },[])

    // EVENT HANDLERS
    const inputHandler = (e:React.FormEvent<HTMLInputElement>) => {
        const txt = e.currentTarget.value.toLowerCase()        
        setSearchText(txt);        
    }

    const onSelectedHandler = (i:number) => {        
        setopen(false);
        setHasTyped(false);     
        setSearchText(""); 
        navigate(`search/${predictions[i].name}`)        
    }
        
    const keyDownHandler = (e:React.KeyboardEvent<object>) => { 
        if(e.key==="Enter"){
            e.preventDefault();
            setopen(false);
            navigate(`/search/${searchText}`)            
        }        
    }

    const keyUpHandler = (e:React.KeyboardEvent<object>) => {
        e.preventDefault();
        setHasTyped(true);
    }

    return (
    <div className={cn("relative flex",className)} ref={ref}>
        {/* <form className=""> */}        
        <Popover open={isOpen}>
            <PopoverTrigger asChild>
                <div className="relative w-full flex items-center">
                    <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                        <Search className="h-6 w-6 text-muted-foreground" />
                    </div>
                    <Input
                    type="search"
                    placeholder={props.placeHolder || "¿En qué necesitas ahorrar hoy?"}
                    className="pl-10 w-full bg-white text-base h-14 font-semibold rounded-full border-gray-600  focus:border-orange-500 focus:ring-0 focus:outline-none placeholder:font-normal placeholder:text-muted-foreground"
                    value={searchText}
                    onChange={inputHandler}                      
                    onKeyDown={keyDownHandler}
                    onKeyUp={keyUpHandler}             
                    ref={searhBarRef}
                    />
                </div>
            </PopoverTrigger>
            <PopoverContent className="w-[500px] p-4">
                <Command>
                    <CommandList>
                        <CommandGroup className="p-0">
                            {
                            predictions.map((pred,i) => {
                                return (
                            <CommandItem
                                key={i}
                                onSelect={()=>{
                                    onSelectedHandler(i)                                    
                                }}
                            >
                                <SearchItem className="" 
                                    name={pred.name} 
                                    picture={pred.picture} 
                                    brand={pred.brand}/>
                            </CommandItem>
                                )
                            })
                            }
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    {/* </form> */}
    </div>);
});

interface SearchItemProps extends React.HTMLAttributes<HTMLDivElement>{
    name:string,
    picture:string, 
    brand:string
}

const SearchItem  = React.forwardRef<HTMLDivElement,SearchItemProps>(({className,name,picture,brand,...props},ref) => {
    return (
        <div className={`flex flex-row gap-2 w-full items-center ${className}`} ref={ref}>
            <div className="w-10 h-10">
                <img src={picture} alt="" className="object-cover"/>
            </div>       
            <div className="text-sm">
                <span className="text-muted-foreground">{brand} - </span><span className="font-semibold">{name}</span>
            </div>     
        </div>
    )
})

